import { Provider } from '@angular/core';
import { AuthenticationService } from '../authentication';
import { TokenService } from '../authentication/parameters';
import { AuthenticationService as RemoteAuthenticationService } from 'projects/authentication/src/app/services';
import { CacheService } from 'projects/common/src/app/services';
import { Router } from '@angular/router';
import { CommunicationSecurityService } from '../communication';
import { UrlBuilderService } from 'projects/communication/src/app/services';

/**
 * Provee la contrucción de una instancia del servicio que se encvargará de las
 * comunicaciones remotas y que implementará la interfaz de comunicaión remota
 *
 * IRemoteCommunication
 */
const authenticationServiceFactory = (cacheService, tokenService, router, http, urlBuilder) => {
  return new RemoteAuthenticationService(cacheService, tokenService, router, http, urlBuilder);
};

/**
 * Provider que define el alias para la utilización del servicio que se encargará
 * de la comunicación remota y que implementará el método loginServiceFactory
 * para la creación
 */
export const authenticationServiceProvider: Provider = {
  provide: AuthenticationService,
  useFactory: authenticationServiceFactory,
  deps: [CacheService, TokenService, Router, CommunicationSecurityService, UrlBuilderService],
};
